import React, { FC } from 'react';

interface SubtractIconProps {
  width?: string | number;
  height?: string | number;
  classes?: string;
}

const SubtractIcon: FC<SubtractIconProps> = ({
  width = '24',
  height = '24',
  classes = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M1.38462 13.3846C0.992308 13.3846 0.663539 13.2518 0.398308 12.9863C0.132769 12.7207 0 12.3918 0 11.9995C0 11.6069 0.132769 11.2781 0.398308 11.0132C0.663539 10.748 0.992308 10.6154 1.38462 10.6154H22.6154C23.0077 10.6154 23.3365 10.7481 23.6017 11.0137C23.8672 11.2792 24 11.6081 24 12.0004C24 12.393 23.8672 12.7218 23.6017 12.9867C23.3365 13.252 23.0077 13.3846 22.6154 13.3846H1.38462Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SubtractIcon;
